import { render, staticRenderFns } from "./c_bg_color.vue?vue&type=template&id=de0dd994&scoped=true"
import script from "./c_bg_color.vue?vue&type=script&lang=js"
export * from "./c_bg_color.vue?vue&type=script&lang=js"
import style0 from "./c_bg_color.vue?vue&type=style&index=0&id=de0dd994&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0dd994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de0dd994')) {
      api.createRecord('de0dd994', component.options)
    } else {
      api.reload('de0dd994', component.options)
    }
    module.hot.accept("./c_bg_color.vue?vue&type=template&id=de0dd994&scoped=true", function () {
      api.rerender('de0dd994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_bg_color.vue"
export default component.exports